import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsBellFill } from 'react-icons/bs';
import { useRealtime } from '../../context/RealtimeContext';
import '../../styles/notificationBell.css';

function timeAgo(dateStr) {
  const d = new Date(dateStr);
  const diff = Math.max(0, Date.now() - d.getTime());
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

const NotificationBell = () => {
  const navigate = useNavigate();
  const { notifications, unreadCount, markRead, markAllRead, refreshNotifications } = useRealtime();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) refreshNotifications();
  };

  const handleClick = (n) => {
    if (!n.read) markRead(n._id);
    const bookingId = n.data?.bookingId;
    setOpen(false);
    if (bookingId) {
      navigate('/profile');
    }
  };

  return (
    <div className="notif-bell-container" ref={ref}>
      <button className="notif-bell-btn" onClick={toggle} title="Notifications" aria-label="Notifications">
        <BsBellFill />
        {unreadCount > 0 && (
          <span className="notif-bell-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
        )}
      </button>

      {open && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">
            <span>Notifications</span>
            {unreadCount > 0 && (
              <button className="notif-mark-all" onClick={markAllRead}>Mark all read</button>
            )}
          </div>
          <div className="notif-list">
            {(!notifications || notifications.length === 0) && (
              <div className="notif-empty">You're all caught up.</div>
            )}
            {notifications && notifications.map((n) => (
              <button
                key={n._id}
                className={`notif-item ${n.read ? '' : 'unread'}`}
                onClick={() => handleClick(n)}
              >
                <div className="notif-item-title">{n.title}</div>
                {n.body && <div className="notif-item-body">{n.body}</div>}
                <div className="notif-item-time">{timeAgo(n.createdAt)}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
